var map = {
  "./answerCountOnPresentingScreen.js": "60941",
  "./customReportColumns.js": "35904",
  "./folderColoursEnabled.js": "84968",
  "./folderDuplication.js": "63484",
  "./quizCountdownSeconds.js": "88247"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = () => (Object.keys(map));
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = 26622;
